// extracted by mini-css-extract-plugin
module.exports = {"light-animation":"HomeContentThree_light-animation__2ee5j"};